import { useMemo } from 'react'

import { HighlightsWidgetType } from 'features/views/LayoutEditor/widgets/HighlightsWidget/types'
import { useRecordManagerContext } from 'features/views/RecordManager/useRecordManagerContext'

import { useHighlightsWidgetItems } from './useHighlightsWidgetItems'

type UseHighlightsWidgetStateProps = {
    widget: HighlightsWidgetType
}

export function useHighlightsWidgetState({ widget }: UseHighlightsWidgetStateProps) {
    const { record, isLoadingSlow } = useRecordManagerContext()

    const { visibleItems } = useHighlightsWidgetItems(widget)

    const showItemLabel = widget.attrs.showItemLabel ?? true

    const hasItems = visibleItems.length > 0

    const hasRecord = !!record

    const style = widget.attrs.style ?? 'minimal'

    const showItemIcon = widget.attrs.showItemIcon ?? true

    const editableFields = useMemo(() => {
        return visibleItems.map((item) => item.field)
    }, [visibleItems])

    return useMemo(
        () => ({
            isLoadingSlow,
            showItemLabel,
            hasItems,
            hasRecord,
            style,
            visibleItems,
            showItemIcon,
            editableFields,
        }),
        [
            isLoadingSlow,
            showItemLabel,
            hasItems,
            hasRecord,
            style,
            visibleItems,
            showItemIcon,
            editableFields,
        ]
    )
}
